<div class="hero" [style.backgroundImage]="'url(' + backgroundImageUrl + ')'">
  <div class="hero-content">
    <h1>{{ title }}</h1>
    <p class="hero-description">{{ description }}</p>
    <button class="cta-button" (click)="navigateToRequestAccess()">{{ buttonText }}</button>
  </div>
</div>